import { render, staticRenderFns } from "./ListConfiguration.vue?vue&type=template&id=427b5100&scoped=true&"
import script from "./ListConfiguration.vue?vue&type=script&lang=js&"
export * from "./ListConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ListConfiguration.vue?vue&type=style&index=0&id=427b5100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427b5100",
  null
  
)

export default component.exports